'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { Chip } from '@7f-ui/components/chip/chip';
import { trackClickCta } from '@feat/feat-tracking/cta';
import { CardsThree, User } from '@phosphor-icons/react';
import { formatDateWithoutYear } from '@utils/utils-format';
import { shopTestId } from '@utils/utils-shop-test-ids';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import { useExperienceOptions } from '../_hooks/use-app-experience-options';
import { useAppExperiencePersonsLabel } from '../_hooks/use-app-experience-persons-label';
import { FilterType } from '../_lib/experience-booking-utils';
import { useExperienceFilterContext } from './app-experience-filter-provider';
const DateChip = dynamic(() => import('./date-chip').then(m => m.DateChip), {
  ssr: false
});
type AppExperienceOffersFilterProps = {
  selectedDate?: string;
  isCartItem?: boolean;
  className?: string;
  onSelect: (filterType: FilterType) => void;
};
export function AppExperienceOffersFilter(t0) {
  const $ = _c(35);
  const {
    selectedDate,
    isCartItem: t1,
    className,
    onSelect
  } = t0;
  const isCartItem = t1 === undefined ? false : t1;
  const {
    experience,
    filter
  } = useExperienceFilterContext();
  const {
    allOptions
  } = useExperienceOptions(experience.variants);
  let t2;
  if ($[0] !== allOptions || $[1] !== filter.selectedOptions) {
    t2 = {
      allOptions,
      selectedOptions: filter.selectedOptions,
      fallback: "Personen w\xE4hlen"
    };
    $[0] = allOptions;
    $[1] = filter.selectedOptions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const personLabel = useAppExperiencePersonsLabel(t2);
  let t3;
  bb0: {
    if (!filter.from) {
      t3 = "ab heute";
      break bb0;
    }
    let t4;
    if ($[3] !== filter.from) {
      t4 = formatDateWithoutYear(filter.from);
      $[3] = filter.from;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    const from = t4;
    const to = filter.to && formatDateWithoutYear(filter.to);
    if (from === to || !to) {
      t3 = from;
      break bb0;
    }
    t3 = `${from} – ${to}`;
  }
  const formattedRange = t3;
  let t4;
  if ($[5] !== filter.from || $[6] !== filter.to || $[7] !== isCartItem) {
    t4 = () => {
      if (isCartItem) {
        return true;
      } else {
        if (filter.from || filter.to) {
          return true;
        } else {
          return false;
        }
      }
    };
    $[5] = filter.from;
    $[6] = filter.to;
    $[7] = isCartItem;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isActive = t4;
  let t5;
  if ($[9] !== className) {
    t5 = cx("flex w-full flex-wrap gap-2 sm:flex-col sm:items-start sm:gap-4 md:flex-row", className);
    $[9] = className;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== experience.variants || $[12] !== filter.selectedVariant || $[13] !== onSelect) {
    t6 = experience.variants.length > 1 && <Chip variant="blue" active={true} IconStart={CardsThree} onClick={() => {
      trackClickCta("option", {
        type: "experience"
      });
      onSelect(FilterType.variant);
    }} data-testid={shopTestId("ExperienceOffersFilter.variant")}>{experience.variants.find(v => v.id === filter.selectedVariant)?.title}</Chip>;
    $[11] = experience.variants;
    $[12] = filter.selectedVariant;
    $[13] = onSelect;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== onSelect) {
    t7 = () => {
      trackClickCta("person selector", {
        type: "experience"
      });
      onSelect(FilterType.person);
    };
    $[15] = onSelect;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = shopTestId("ExperienceOffersFilter.person");
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== personLabel || $[19] !== t7) {
    t9 = <Chip variant="blue" active={true} IconStart={User} onClick={t7} data-testid={t8}>{personLabel}</Chip>;
    $[18] = personLabel;
    $[19] = t7;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = isActive();
  let t11;
  if ($[21] !== onSelect) {
    t11 = () => {
      trackClickCta("calendar", {
        type: "experience"
      });
      onSelect(FilterType.date);
    };
    $[21] = onSelect;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = shopTestId("ExperienceOffersFilter.date");
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== filter || $[25] !== formattedRange || $[26] !== selectedDate || $[27] !== t10 || $[28] !== t11) {
    t13 = <DateChip filter={filter} todayLabel="ab heute" formattedRange={formattedRange} selectedDate={selectedDate} active={t10} onClick={t11} testId={t12} />;
    $[24] = filter;
    $[25] = formattedRange;
    $[26] = selectedDate;
    $[27] = t10;
    $[28] = t11;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t5 || $[32] !== t6 || $[33] !== t9) {
    t14 = <div className={t5}>{t6}{t9}{t13}</div>;
    $[30] = t13;
    $[31] = t5;
    $[32] = t6;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}